import { useState } from "react";
import { cn } from "@/lib/utils";
import { initials } from "../../../shared/format";

interface Props {
  fullName: string;
  /** Ảnh Zalo HIS lưu khi bệnh nhân đăng nhập Mini App; không có thì hiện chữ viết tắt. */
  zaloAvatarUrl?: string | null;
  /** Ảnh HIS lưu (tải lên / migrate); ưu tiên hơn ảnh Zalo. */
  avatarUrl?: string | null;
  className?: string;
}

/**
 * Ảnh đại diện bệnh nhân: ảnh Zalo nếu có, ngược lại chữ viết tắt của họ tên.
 *
 * <p>URL ảnh Zalo có thể hết hạn hoặc bị xoá phía Zalo — tải hỏng thì lùi về chữ viết tắt thay vì
 * để một ô ảnh vỡ.
 */
export function PatientAvatar({ fullName, zaloAvatarUrl, avatarUrl, className }: Props) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const url = avatarUrl || zaloAvatarUrl;
  const showImage = !!url && failedUrl !== url;

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/10 font-semibold text-primary",
        className,
      )}
      aria-hidden="true"
    >
      {showImage ? (
        <img
          src={url}
          alt=""
          referrerPolicy="no-referrer"
          className="h-full w-full object-cover"
          onError={() => setFailedUrl(url)}
        />
      ) : (
        initials(fullName)
      )}
    </div>
  );
}
